import * as React from "react";
import { IdFortuneTellerEvent } from "../../../constants/IdFortuneTellerEvent";
import { utilRandom } from "../../../utils/utilRandom";
import { CrystalBallStarsAnimation } from "./CrystalBallStarsAnimation";
export var getRandomPercentage = function () { return utilRandom.getRandomNumberInRange(1, 100) + "%"; };
export var getRandomStyle = function () {
    var getRandomSize = utilRandom.getRandomNumberInRange(10, 30) + "px";
    return {
        animationDelay: Math.random() * 10 + "s",
        animationDuration: "3s",
        animationIterationCount: "infinite",
        animationName: "twinkle",
        height: getRandomSize,
        left: getRandomPercentage(),
        top: getRandomPercentage(),
        width: getRandomSize,
    };
};
export var getStaticStarsAnimation = function () { return (React.createElement(React.Fragment, null, Array.from({ length: IdFortuneTellerEvent.TwinklingStarsCount }, function (value, index) { return (React.createElement("div", { className: "star fortune-teller-event__star-particle", key: index, style: getRandomStyle() })); }))); };
export var CrystalBallAnimation = React.memo(function () { return (React.createElement("div", { className: "crystal-ball-animation" },
    React.createElement("div", { className: "stars-container" }, getStaticStarsAnimation()),
    React.createElement("div", { className: "revolving-stars-container" },
        React.createElement(CrystalBallStarsAnimation, null)))); });



//////////////////
// WEBPACK FOOTER
// ./src/features/fortune-teller-event/components/CrystalBallAnimation.tsx
// module id = 611
// module chunks = 3